import axios from "axios";

export const AxiosConfigAuthentication = () => {
  const token = localStorage.getItem(
    `${process.env.REACT_APP_PREFIX}_access_token`
  );
  const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return instance;
};
